module.exports = __webpack_public_path__ + "img/hok5.94972e72.png";